export default {
  translation: {
    name: 'Информация о профиле',
    placeholders: {
      login: 'Ваш ник',
      username: 'Имя пользователя',
      password: 'Пароль',
      passwordConfirmation: 'Подтвердите пароль',
    },
    entry: 'Войти',
    exit: 'Выйти',
    loginTitle: 'Войдите в свой аккаунт',
    registrationTitle: 'Введите данные для регистрации',
    registration: 'Регистрация',
    makeRegistration: 'Уже зарегистрированы?',
    noAccount: 'Нет аккаунта?',
    pageNotFound: 'Страница не найдена',
    redirect: 'Но вы можете перейти ',
    mainPage: 'на главную страницу',
    registrationRules: {
      name: 'От 3 до 20 символов',
      password: 'Не менее 4 символов',
      passwordEquality: 'Пароли должны совпадать',
    },
    errors: {
      userExist: 'Такой пользователь уже существует',
      required: 'Обязательное поле',
      auth: 'Введите правильные имя пользователя/пароль',
      network: 'Ошибка соединения',
    },
  },
};
